import Show from './Show';
import Create from './Create';
import Edit from './Edit';
import List from './List';
import Profile from './Profile';
export { Show, Create, Edit, List, Profile}
export default { Show, Create, Edit, List, Profile}
